<template>
<div class="animated fadeIn mt-5" v-if="dataLoaded">
  <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)">
    <div class="row">
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Item</strong>
          </div>
          <b-form-group label="Ano / Mês">
            <b-form-input type="number" step="1" min="201900" name="ym" v-model="item.ym" placeholder="Ano / Mês"  v-validate="'required'" :state="validateState('ym')"></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('ym') }}
            </b-form-invalid-feedback>
          </b-form-group>

          <modal-select modal="dealers-modal" name="dealer_id" :readonly="false" :item-id="item.dealer_id" :item-name="item.dsr?item.dealer.data.name:''" v-on:select-item="selectDealer"  :state="validateState('dealer_id')" placeholder="Distribuidor" label="Distribuidor" ></modal-select>
          <modal-select modal="dsr-modal" name="dsr_id" :readonly="false" :item-id="item.dsr_id" :item-name="item.dsr?item.dsr.data.name:''" v-on:select-item="selectDsr"  :state="validateState('dsr_id')" placeholder="DSR" label="DSR" ></modal-select>
          <modal-select modal="prodaggreg-modal" v-validate="'required'" name="prodaggreg_id" :readonly="item.id>0" :item-id="item.prodaggreg_id" :item-name="item.prodaggreg?item.prodaggreg.data.name:''" v-on:select-item="selectProdaggreg"  :state="validateState('prodaggreg_id')" placeholder="Prodaggreg" label="Prodaggreg" ></modal-select>

          <b-form-row>
            <b-col md="3">
              <b-form-group label="Conquistas">
                <b-form-input type="number" step="1" min="0" name="operator" v-model="item.operator" placeholder="Conquistas"  v-validate="'required'" :state="validateState('operator')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('operator') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Min Conquistas">
                <b-form-input type="number" step="1" min="0" name="min_units_operator" v-model="item.min_units_operator" placeholder="Conquistas"  v-validate="'required'" :state="validateState('min_units_operator')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('min_units_operator') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Quantidade">
                <b-form-input type="number" step="1" min="0" name="quantity" v-model="item.quantity" placeholder="Quantidade"  v-validate="'required'" :state="validateState('quantity')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('quantity') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Min Qtd">
                <b-form-input type="number" step="1" min="0" name="min_units_quantity" v-model="item.min_units_quantity" placeholder="Conquistas"  v-validate="'required'" :state="validateState('min_units_quantity')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('min_units_quantity') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

          </b-form-row>


          <div slot="footer">
            <div class="row">
              <div class="col-sm-3">
                <router-link :to="{name:'criteria.index'}" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancelar</router-link>

              </div>
              <div class="col-sm-9 text-right">
                <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
                <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar e fechar</b-button>
              </div>
            </div>
          </div>
        </b-card>


      </b-col>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Debug </strong>
          </div>
          <pre>
            {{ item }}
          </pre>

        </b-card>
      </b-col>
      <!--/.col-->
    </div>
  </form>

</div>
</template>

<script>
export default {
  name: 'BestofDsrObjectiveEdit',
  props: ['id'],
  components: {},
  data() {
    return {
      dataLoaded: false,
      modalType: '',
      showModal: false,
      item: {
        zone: '',
        dealer: {
          data: {
            id: null,
            name: ''
          }
        },
        prodaggreg: {
          data: {
            id: null,
            name: ''
          }
        },
        dsr: {
          data: {
            name: '',
            id: null
          }
        },
        quantity: 0,
        operator: 0,
        min_units_operator: 0,
        min_units_quantity: 0
      }
    }
  },
  methods: {
    selectDsr(e) {
      if(e.item) {
        this.item.dsr_id = e.item.id
        this.item.dsr.data = e.item
      } else {
        this.item.dsr_id = null
        this.item.dsr.data = {id: null, name:null}
      }
    },
    selectDealer(e) {
      if(e.item) {
        this.item.dealer_id = e.item.id
        this.item.dealer.data = e.item
      } else {
        this.item.dealer_id = null
        this.item.dealer.data = {id: null, name:null}
      }
    },
    selectProdaggreg(e) {
      console.log(e)
      this.item.prodaggreg_id = e.item.id
      this.item.prodaggreg.data = e.item
    },
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast(`Tem campos inválidos`, { autoHideDelay: 5000, variant: 'danger', solid: true })
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item
      }
      if (this.item.id) {
        this.axios.put('inpar/criteria' + '/' + this.item.id, data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            if (close) {
              this.$router.push({
                name: 'criteria.index'
              })
            }
          })
          .catch(response => {
            this.$bvToast.toast(`Não foi possivel gravar`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      } else {
        this.axios.post('inpar/criteria', data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            this.$router.push({
              name: 'criteria.edit',
              params: {
                id: this.item.id
              }
            })
          })
          .catch(response => {
            this.$bvToast.toast(`Não foi possivel gravar`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      }
    }
  },
  created() {
    var id = this.$route.params.id
    if (typeof id !== 'undefined') {
      this.axios.get('inpar/criteria' + '/' + id)
        .then(response => {
          this.item = response.data.data
          this.dataLoaded = true
          if(!this.item.dealer_id) {
            this.item.dealer = {
              data: {
                id: null,
                name: null,
              }
            }
          }
          if(!this.item.dsr_id) {
            this.item.dsr = {
              data: {
                id: null,
                name: null,
              }
            }
          }
        })
        .catch(response => {
          this.$bvToast.toast(`Este critério não existe`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          this.$router.push({
            name: 'criteria.index'
          })
        })
    } else {
      this.dataLoaded = true
    }
  }
}
</script>
